import { memo } from 'react';
import { ListItem, Theme, Typography, useEventCallback } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import classNames from 'classnames';
import { makeStyles, createStyles } from '@mui/styles';
import { JSONToCSVConverter } from 'shell/utils/csv-transformer';

interface CsvExtractionProps {
  id?: string;
  label?: string;
  dataToExtract?: Array<Record<string, string>>;
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    icon: {
      color: theme.palette.cdmBrandThird.main,
    },
  });
});

const CsvExtractionComponent = ({
  id = 'extract-csv-format',
  dataToExtract,
  label = 'Estrai lista in formato csv',
  title = '',
  onClick,
  disabled,
}: CsvExtractionProps) => {
  const styles = useStyles();

  const handleClick = useEventCallback(() => {
    if (onClick) {
      onClick();
      return;
    }
    JSONToCSVConverter({ json: dataToExtract, title });
  });

  return (
    <ListItem
      style={{ padding: '0', width: 'auto', display: 'inline-flex' }}
      button
      onClick={handleClick}
      id={id}
      disabled={disabled}
    >
      <div className={classNames('pmi-d-flex pmi-p-2', styles.icon)}>
        <ArticleIcon />
      </div>
      <Typography color="primary.main" className=" pmi-pl-0 pmi-py-2 pmi-pr-2">
        {label}
      </Typography>
    </ListItem>
  );
};

CsvExtractionComponent.displayName = 'Csv extraction Component';

export const CsvExtraction = memo(CsvExtractionComponent);
